// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"query_wrapper__3-mIA","header":"query_header__3tEs_"};